import React, { useCallback } from "react";
import { useNavigate } from "react-router";
import { PermissionedRoute } from "@/components/auth/PermissionedRoute";
import { OpsProgenyReviewPageContent } from "@/routes/ops.progeny.review";
import { useWindowId } from "./OsWindow";
import { useOsActions } from "./OsContext";

export interface OsProgenyReviewWindowBridgeProps {
  /** Progeny review id from OS window params */
  reviewId: string;
}

/**
 * Progeny review page with OS-aware "back" (updates current window to processing
 * sub-route when running inside an aniOS window).
 *
 * @see {@link ../../../../docs/os-aware-navigation.md}
 */
export function OsProgenyReviewWindowBridge({ reviewId }: OsProgenyReviewWindowBridgeProps) {
  const windowId = useWindowId();
  const { updateWindow } = useOsActions();
  const navigate = useNavigate();

  const onBack = useCallback(() => {
    if (windowId) {
      updateWindow(windowId, {
        params: { subRoute: "processing" },
        title: "Progeny Processing",
      });
    } else {
      navigate("/ops/progeny/processing");
    }
  }, [windowId, updateWindow, navigate]);

  return (
    <PermissionedRoute module="ops">
      <OpsProgenyReviewPageContent reviewId={reviewId} onBack={onBack} />
    </PermissionedRoute>
  );
}
